import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, BadgeCheck, Clock, FileText, ArrowRight } from 'lucide-react';

const Row = ({ label, value, tone }) => {
  const verified = tone === 'verified';
  return (
    <div
      className="flex items-start justify-between gap-3"
      data-testid={`reg-row-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`}
    >
      <span className="text-[11px] font-bold uppercase tracking-wider text-white/55 font-mono pt-1">{label}</span>
      <span
        className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border whitespace-nowrap ${
          verified
            ? 'text-[#00FFD1] border-[#00FFD1]/40 bg-[#00FFD1]/10'
            : 'text-amber-300 border-amber-400/30 bg-amber-400/10'
        }`}
      >
        {verified ? <BadgeCheck size={13} /> : <Clock size={13} />}
        {value}
      </span>
    </div>
  );
};

/** Local Philippine regulatory & compliance placeholders. */
export const RegulatoryCompliance = ({ className = '' }) => (
  <div
    className={`bg-[#00FFD1]/[0.03] border border-[#00FFD1]/20 rounded-lg p-6 ${className}`}
    data-testid="product-regulatory"
  >
    <h3 className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#00FFD1] font-mono mb-4 flex items-center gap-2">
      <ShieldCheck size={14} /> Local Regulatory &amp; Compliance Details
    </h3>
    <div className="space-y-3">
      <Row label="Authorized Distribution" value="FMSInc. — Verified Distributor" tone="verified" />
    </div>
  </div>
);

/** High-visibility brochure / quotation call-to-action. */
export const BrochureCTA = ({ className = '', productName = null }) => (
  <Link
    to="/contact-ph"
    state={productName ? { productName } : undefined}
    data-testid="request-brochure-cta"
    className={`group flex items-center justify-between gap-4 w-full bg-gradient-to-r from-[#00FFD1] to-[#00B4D8] text-black font-bold rounded-lg px-6 py-4 hover:shadow-[0_12px_40px_-8px_rgba(0,255,209,0.55)] transition-shadow ${className}`}
  >
    <span className="flex items-center gap-3">
      <FileText size={20} />
      <span className="text-base">Request Technical Brochure / Quotation</span>
    </span>
    <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
  </Link>
);

export default RegulatoryCompliance;
